import { createAsyncThunk } from "@reduxjs/toolkit";
import DepartmentService from "services/DepartmentService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import FileService from "services/FileService";
let initialState = { list: [], detail: null };

export const getDepartmentDetail = createAsyncThunk(
  "department/getDepartmentDetail",
  async (empId) => {
    const response = await DepartmentService.list({ empId });
    if (response.status && response?.results?.length > 0) {
      return response?.results[0];
    }
  }
);

export const updateDepartment = createAsyncThunk(
  "department/updateDepartment",
  async (body) => {
    const response = await DepartmentService.updateDepartment(body);
    if (response.status) {
      const response2 = await DepartmentService.list({
        departmentId: body.departmentId,
      });
      if (response2.status && response2?.results?.length > 0) {
        return response2?.results[0];
      }
    }
  }
);

export const getPrintList = createAsyncThunk(
  "department/getPrintList",
  async (body) => {
    const response = await DepartmentService.listPrintFile(body);
    if (response.status && response?.results?.length > 0) {
      return response?.results;
    }
  }
);

export function AddDepartment(data, fileimg) {
  return async (dispatch) => {
    // console.log(data);
    // dispatch(loginRequest());

    try {
      const response = await DepartmentService.AddDepartment(data);
      const results = response?.results || {};

      /// UPLOAD IMAGE
      if (response?.results.departmentId !== "") {
        try {
          const responseimg = await FileService.uploadFileImageDepartment({
            file: fileimg,
            Status: true,
            departmentId: response?.results.departmentId,
          });
          // HttpClient.setToken(results.accessToken);
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "Success!",
              "เพิ่มหน่วยงานสำเร็จ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                // console.log(respose.data.id);
              }
            });
          });
        } catch (error) {
          console.log("Upload error", error);
        }
      }

      // Router.replace("/");
    } catch (error) {
      alert("Opps!!! " + error.message);
      throw error;
    }
  };
}
